import React from 'react';
import LoginLogo from '../../assets/images/Logo-Fanhub-v-big.png'; // Adjust the import path as necessary

const LoginElement = () => {
  return (
    <div className="l-element">
      <div className="l-image">
        <img src={LoginLogo} alt="Company logo" className="image-full" />
      </div>
      <p>Your place for discussions, stories, and creatives to share and connect with like-minded people!</p>
    </div>
  );
};

export default LoginElement;